module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BasePage', {
    attrs: {
      "title": "Home"
    }
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-10-fullhd is-offset-1-fullhd"
  }, [_c('Videos')], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-39c6fddb"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BasicHome.vue
// module id = 1008
// module chunks = 0